import { render, staticRenderFns } from "./ReturnGoods4.vue?vue&type=template&id=442563cb&"
import script from "./ReturnGoods4.vue?vue&type=script&lang=ts&"
export * from "./ReturnGoods4.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnGoods4.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports